import styled from 'styled-components';

export const shipperUserStyles = (Component) => styled(Component)`
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  right: 0;
  position: fixed;
  width: 336px;
  height: 100vh;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.4);
  background-color: var(--grey300);
  display: none;

  &&.open {
    display: block;
  }

  .header {
    padding: 0px 24px;
    height: 48px;
    font-size: 16px;
    line-height: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--grey100);
    background-color: var(--grey800);

    &__close:hover {
      cursor: pointer;
    }
  }
  .content {
    overflow-y: auto;
    height: calc(100vh - 161px);
    padding: 24px;

    &__title {
      font-weight: bold;
      margin-bottom: 16px;
      color: var(--grey900);
      height: 16px;
    }
  }

  .input {
    width: 288px;
    margin-bottom: 16px;
  }

  .margin-top {
    margin-top: 32px;
  }

  .subtitle {
    color: var(--grey700);
    font-weight: 500;
    margin-top: 16px;
    margin-bottom: 8px;
  }

  .textarea {
    width: 288px;
    textarea {
      height: 96px;
    }
  }
`;
